import { getDataBase } from '@/db';
import FechaHora from '@/utils/FechaHora';


/**
 *  Capa de Acceso a Datos (DAL) para la tabla GENERACIONLECTURAFOTO en IndexedDB.
 * 
 * @author Ing Crisitan Cuellar
 * @date 2025-03-07
 */
export default class GeneracionLecturaFotoDAL {

     /**
     * Obtiene todas las imágenes de un cliente específico.
     * 
     * @param {number} tnCliente - Codigo de cliente.
     * @returns {Promise<Array>} - Lista de imágenes.
     */
    static getOnly = async (tnCliente) => {
        try {
          const db = await getDataBase();
          const tx = db.transaction('GENERACIONLECTURAFOTO', 'readonly');
          const store = tx.objectStore('GENERACIONLECTURAFOTO');
          const laResultado = await store.index('Cliente').getAll(Number(tnCliente));
          await tx.done;
          return laResultado;
        } catch (error) {
          throw new Error('Error al obtener las imagenes del cliente '+ tnCliente);
        }
    }


    static async imagenStore( taImagenFiles, GeneracionFactura, Cobro, CodigoUbicacion, Cliente, EmpresaNombre, DataBaseAlias,taImagesSizes ) {
            try {
         
                //TODO: cambiar el nombre de la tabla a GEneracionLecturaFoto
                const db = await getDataBase(); 
                const tx = db.transaction('GENERACIONLECTURAFOTO', 'readwrite');
                const store = tx.objectStore('GENERACIONLECTURAFOTO');
                const loFechaHora = new FechaHora();
    
                // const file = imagen;
                // const url = `${EmpresaNombre}/Foto`; // Ubicación del archivo
                const contarImagenes = taImagenFiles.length;
                const namePDF = `${GeneracionFactura}_${Cobro}_${CodigoUbicacion}_${Cliente}_${loFechaHora.getFecha()}_${loFechaHora.getHoraArchivo()}`;
        
                for (let i = 0; i < contarImagenes; i++) {
                    const fileName = `${namePDF}_${i + 1}.jpg`; // Nombre del archivo
                    const path = `${EmpresaNombre}/Foto/${fileName}`; // Ubicación
                    const loSize = taImagesSizes[i];
    
                    const imageData = {
                        Cliente: Number(Cliente) ,  // Usa un ID único combinando cliente e índice
                        GeneracionFactura: Number(GeneracionFactura),
                        Serial: i + 1,
                        FotoNombre: fileName,
                        size: loSize,
                        Foto: path,
                        imageFile: taImagenFiles[i],
                        EmpresaNombre: EmpresaNombre
                    };
    
                    await store.add(imageData); // Guarda la imagen en la tabla 'GENERACIONLECTURAFOTO'
                    console.log(`Imagen ${i + 1} guardada en IndexedDB`);
                }
                await tx.done;
                return 1;
            } catch (error) {
                // Guardar el error en el log
                console.error('Error en el metodo imagenStore:', error);
                
                // guardarLog(true, 'ErrorSubidaImagen', 'Error:', error.message, error.fileName, 'Linea: ' + error.lineNumber, error.stack);
                return 0;
            }
        }
    
}